import { render, staticRenderFns } from "./SinglePspMethod.vue?vue&type=template&id=6cf6a1be&scoped=true"
import script from "./SinglePspMethod.vue?vue&type=script&lang=js"
export * from "./SinglePspMethod.vue?vue&type=script&lang=js"
import style0 from "./SinglePspMethod.vue?vue&type=style&index=0&id=6cf6a1be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf6a1be",
  null
  
)

export default component.exports